export default __webpack_public_path__ + "static/media/scene_04.e2cd5bb9.mp3";